import { actionKitImpFunction } from '../../../../../components/ozmoit/common';
import {
  ExportStudentsRiskHistoryParams,
  exportStudentsRiskHistory,
  getPrimaryFiltersOptions,
  getStudentsRiskHistory,
  getStudentsRiskHistoryDetails,
} from '../api';
import {
  StudentsRiskHistoryParams,
  StudentsRiskHistoryDetailsRouteParams,
} from '../types';

const getPrimaryFiltersOptionsAction = actionKitImpFunction(async () => {
  const response = await getPrimaryFiltersOptions();
  if (response.error) {
    throw new Error('Error fetching form data');
  }
  const { data } = response;
  return data;
});

const StudentsRiskHistoryAction = actionKitImpFunction(
  async (queryParams: StudentsRiskHistoryParams) => {
    const response = await getStudentsRiskHistory(queryParams);
    if (response.error) {
      throw new Error('Error fetching form data');
    }
    const { data } = response;
    return data;
  },
);

const StudentsRiskHistoryDetailsAction = actionKitImpFunction(
  async (params: Partial<StudentsRiskHistoryDetailsRouteParams>) => {
    const response = await getStudentsRiskHistoryDetails(params);
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    return response.data;
  },
);

const exportStudentsRiskHistoryAction = actionKitImpFunction(
  async (params: ExportStudentsRiskHistoryParams) => {
    const response = await exportStudentsRiskHistory(params);
    if (response.error) {
      throw new Error('Error exporting students risk history');
    }
    return response.data;
  },
);

export {
  getPrimaryFiltersOptionsAction,
  StudentsRiskHistoryDetailsAction,
  StudentsRiskHistoryAction,
  exportStudentsRiskHistoryAction,
};
